/**
 * O feed de alertas: o que aconteceu na estufa, mais novo primeiro.
 *
 * Responsabilidade: desenhar a lista e marcar como lido quando ela e vista.
 *
 * NAO e responsabilidade deste arquivo: decidir o que e um alerta (isso e do
 * servidor, `api/app/services/alerts.py`), nem buscar (`acoes.ts`).
 *
 * ## Por que a lista e do TENANT e nao do aparelho selecionado
 *
 * Todo o resto desta tela e sobre o aparelho que esta no trilho — leituras,
 * saidas, timelapse, comandos. Este painel nao: quem abre o painel remoto as
 * 3 da manha nao quer descobrir que precisa clicar em cada barraca para achar
 * qual apitou. Por isso cada linha carrega o nome do aparelho no proprio
 * titulo, ja escrito pelo servidor.
 *
 * ## O texto vem PRONTO do servidor, e isso e desenho
 *
 * Nada aqui remonta frase a partir de `kind`/`estado`/`dados`. O servidor
 * renderiza `titulo` e `corpo` no instante do fato e grava assim; se a tela
 * remontasse, um alerta de tres dias atras passaria a citar o `dev_name` de
 * hoje e a faixa de VPD do estagio de hoje — e um feed que se reescreve sozinho
 * nao responde "o que aconteceu de madrugada", que e a unica pergunta que ele
 * existe para responder.
 *
 * O que esta camada decide e so a COR: `severidade` escolhe o selo, do mesmo
 * jeito que `desfecho()` faz no feed de comandos.
 */

import * as acoes from "./../acoes";
import * as store from "./../store";
import type { AlertaOut } from "./../tipos";
import { dataHora, el, trocar, type Painel } from "./../ui";

/** Quantas linhas o painel desenha. O resto continua no store e no disco. */
const VISIVEIS = 12;

export function montar(): Painel {
  const lista = el("div", { class: "lista-alertas" });
  const marcar = el(
    "button",
    {
      type: "button",
      class: "link",
      hidden: true,
      onclick: () => void acoes.marcarAlertasLidos(),
    },
    "marcar como lidos",
  );

  const raiz = el(
    "section",
    { class: "panel card", id: "alertas" },
    el(
      "div",
      { class: "panel-head" },
      el("span", { class: "panel-title", text: "Alertas" }),
      marcar,
    ),
    lista,
  );

  function atualizar(): void {
    const estado = store.obter();
    marcar.hidden = estado.naoLidos === 0;

    if (estado.alertas.length === 0) {
      trocar(
        lista,
        el("p", {
          class: "hint",
          text: "Nenhum alerta ainda — e isso é uma boa notícia.",
        }),
      );
      return;
    }
    trocar(lista, ...estado.alertas.slice(0, VISIVEIS).map((a) => linha(a, estado)));
  }

  return { raiz, atualizar };
}

function linha(alerta: AlertaOut, estado: Readonly<store.Estado>): HTMLElement {
  const aparelho = estado.aparelhos.find((a) => a.device.id === alerta.device_id);
  return el(
    "div",
    { class: `alerta ${alerta.read_at === null ? "nao-lido" : ""}`.trim() },
    el(
      "div",
      { class: "alerta-corpo" },
      el("span", { class: "alerta-titulo", text: alerta.titulo }),
      el("span", { class: "alerta-texto", text: alerta.corpo }),
    ),
    el(
      "div",
      { class: "alerta-meta" },
      el("span", { class: `selo ${classe(alerta.severidade)}`, text: alerta.severidade }),
      // A hora do APARELHO quando ha uma (`ts`), e nao a da nuvem: e a mesma
      // disciplina do `ts` da telemetria. Um alerta de backfill — se um dia
      // houver — tem que continuar dizendo quando o fato aconteceu.
      el("span", { class: "hint", text: dataHora(alerta.ts) }),
      // Redundante com o titulo quando o aparelho existe, e util quando ele foi
      // apagado: o alerta some junto por CASCADE, mas ate o proximo GET a linha
      // ainda esta na tela.
      aparelho === undefined &&
        el("span", { class: "hint", text: "aparelho removido" }),
    ),
  );
}

/** Reusa os tres selos do feed de comandos — mesma gramatica visual. */
function classe(severidade: AlertaOut["severidade"]): string {
  if (severidade === "alarme") return "erro";
  if (severidade === "recuperado") return "ok";
  return "pendente";
}
